import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import { getPickerOptionLabel } from "../../../../helpers/et3-picker-data-helper";
import {
  TEt3PickerMultipleValue,
  TEt3PickerOption
} from "../../../../TypesNEW";

const KhattabatFilterMultiSelect = withLiteObserverAndTheme<{
  label: string;
  options: TEt3PickerOption[];
  value: TEt3PickerMultipleValue;
  onChange: (value: TEt3PickerMultipleValue) => void;
}>((props) => {
  const { label, options, value, onChange } = props;
  const visibleOptions = options.filter((option) => option.label !== "");

  return (
    <Autocomplete
      multiple
      size="small"
      fullWidth
      disableCloseOnSelect
      openOnFocus
      disableClearable
      options={visibleOptions}
      value={[...value]}
      getOptionLabel={getPickerOptionLabel}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      onChange={(_, selected) => onChange(selected)}
      noOptionsText={i18n.get("NO_RESULT")}
      openText={i18n.get("KHATTABAT_SELECT_OPEN")}
      closeText={i18n.get("KHATTABAT_SELECT_CLOSE")}
      renderOption={(optionProps, option, { selected }) => {
        const { key, ...liProps } = optionProps;
        return (
          <Box component="li" key={key} {...liProps}>
            <Checkbox size="small" checked={selected} />
            {getPickerOptionLabel(option)}
          </Box>
        );
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
});

export default KhattabatFilterMultiSelect;
